"use strict";

import angular from "angular";

angular.module("nucont.authentication").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.authentication", {
        url: "login",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-authentication" */ "./authentication.component"
            ).then(() => $ocLazyLoad.inject("nucont.authentication"));
        },
        params: {
            redirectToStateName: null,
            redirectToStateParams: null
        },
        views: {
            "main@": {
                component: "emptyLayoutComponent"
            },
            "empty@nucont.authentication": {
                component: "authenticationComponent"
            }
        },
        bodyClass: "authentication-module"
    });
}
